import { render, staticRenderFns } from "./appletServers.vue?vue&type=template&id=612c3143&"
import script from "./appletServers.vue?vue&type=script&lang=js&"
export * from "./appletServers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports